import type { PageMeta } from '@coorum-research/shared-common/types/page-meta.type'
import { getStorageItem, setStorageItem } from './storage.util'

const researchPageMetaStorageKeyPrefix = 'coorum-research-page'

function generateStorageKey() {
  return [researchPageMetaStorageKeyPrefix].join(':')
}

export function getPageMeta() {
  const key = generateStorageKey()
  return getStorageItem<PageMeta>(key, 'session')
}

/**
 * NOTE: userIdを別途 storage保存する？かそのともこのまま？
 */
export function setPageMeta(value: PageMeta) {
  const key = generateStorageKey()
  setStorageItem<PageMeta>(key, value, 'session')
}

